<template>
    <div>
        <Modal :value="is_show" @on-cancel="close_modal" :styles="{top: '150px'}" width="750">
            <p slot="header" class="ivu-modal-header">
                <Icon type="information-circled" />
                <span>选择客户</span>
            </p>
            <div class="search-customer">
                <input class="search-input" v-model="form_search.keyword" type="text" placeholder="请输入客户名或手机号搜索" />
                <button class="btn btn-search" type="button" @click="search">搜索</button>
            </div>
            <div class="pick-customer">
                <div class="row flex align-center" v-for="(item,index) in list" :key="'customer-'+index" @click="toggle_customer(index)">
                    <img style="width: 17px;height: 17px;" :src="getSelectImg(index)" />
                    <div class="flex align-center justify-between"  style="width: 95%; margin-left: 10px;">
                        <div class="title">{{ item.name }}</div>
                        <div class="title">{{ item.mobile }}</div>
                        <div class="title">{{ item.birthday }}</div>
                        <div class="title">{{ item.height }}</div>
                        <div class="title">{{ item.weight }}</div>
                    </div>
                </div>

            </div>
            <div slot="footer">
                <div class="flex align-center justify-around" style="padding-bottom: 10px;">
                    <div class="cancel" @click="close_modal">取消</div>
                    <div class="cancel" @click="reset_modal">清空</div>
                    <div class="submit" @click="pop_customer">确认</div>
                </div>

            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "CustomerList",
        props: {
            list: {
                type: Array,
                default: [],
            },
            is_show: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                selected_ids: [],
                form_search : {
                    keyword: ''
                },
                customer: [],
            }
        },
        methods: {
            reset_modal() {
                this.selected_ids = []
                this.customer = []
            },
            close_modal() {
                this.selected_ids = []
                this.customer = []
                this.$emit('close-modal', false)
            },
            toggle_customer(index) {
                if(!this.selected_ids.includes(index)) {
                    this.customer.push(this.list[index])
                    this.selected_ids.push(index)
                    this.selected_ids = [...(new Set(this.selected_ids))]
                } else {
                    this.selected_ids = this.selected_ids.filter(v => {
                        return v != index
                    })
                    this.customer = this.customer.filter(v => {
                        return v.id != this.list[index].id
                    })

                }
            },
            pop_customer() {
                this.$emit('pop-customer', this.customer)
                this.customer = []
            },
            getSelectImg(index) {
                return this.selected_ids.includes(index) ? require('@/assets/images/select.png')  : require('@/assets/images/no-select.png')
            },
            search() {
                this.$emit('search-customer', this.form_search)
            }
        }
    }
</script>

<style scoped lang="scss">
    .search-customer {
        margin: 0 24px 20px 24px;
        position: relative;
        height: 40px;
        .search-input {
            width: 100%;
            height: 100%;
            padding-left: 10px;
            border: 1px solid #B3B3B3;
            font-size: 15px;
        }
        .btn-search {
            position: absolute;
            width: 70px;
            height: 40px;
            top: 0;
            right: 0;
            background: #FFFFFF;
            font-size: 15px;
            border: 1px solid #B3B3B3;
            color: #676767;
        }
    }
    .pick-customer{
        padding: 14px 24px;
        height: 450px;
        overflow-y:scroll;
        .no-select{
            width: 17px;
            height: 17px;
            border-radius: 50%;
            border: 1px solid #999999;
        }
        .select {
            width: 17px;
            height: 17px;
            border-radius: 50%;
            background-color: #0F114A;

        }
        .row{
            margin-bottom: 20px;
            height: 40px;
            cursor: pointer;
        }
    }
    .submit {
        width: 200px;
        height: 44px;
        line-height: 44px;
        background: #0F114A;
        opacity: 1;
        border-radius: 4px;
        text-align: center;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #EDD4AC;
        margin: 0 auto;
        cursor: pointer;
    }
    .cancel {
        width: 200px;
        height: 44px;
        line-height: 44px;
        background: #FFFFFF;
        border: 1px solid #0F114A;
        border-radius: 4px;
        text-align: center;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #0F114A;
        margin: 0 auto;
        cursor: pointer;
    }
</style>
